export default defineAppConfig({
  ui: {
    primary: 'secondary',
    button: {
      color: {
        gray: {
          solid: 'shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-700 text-gray-700 dark:text-gray-200 bg-gray-300 hover:bg-gray-200 disabled:bg-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700/50 dark:disabled:bg-gray-800 focus-visible:ring-2 focus-visible:ring-primary-500 dark:focus-visible:ring-primary-400'
        }
      }
    },
    notification: {
      progress: {
        base: 'absolute bottom-0 end-0 h-1'
      }
    },
    tooltip: {
      container: 'z-50 group'
    }
  }
})
